export const wiseContractAddress = "0x66a0f676479Cee1d7373f3DC2e2952778BfF5bd6"; //WISE
export const wiseContractABI = [{
  "inputs": [],
  "stateMutability": "nonpayable",
  "type": "constructor"
}, {
  "anonymous": false,
  "inputs": [{
    "indexed": true,
    "internalType": "address",
    "name": "owner",
    "type": "address"
  }, {
    "indexed": true,
    "internalType": "address",
    "name": "spender",
    "type": "address"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "value",
    "type": "uint256"
  }],
  "name": "Approval",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
    "indexed": true,
    "internalType": "bytes16",
    "name": "stakeID",
    "type": "bytes16"
  }, {
    "indexed": true,
    "internalType": "address",
    "name": "stakerAddress",
    "type": "address"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "scrapeAmount",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "scrapeDay",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "stakersPenalty",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "referrerPenalty",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "currentWiseDay",
    "type": "uint256"
  }],
  "name": "InterestScraped",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
    "indexed": false,
    "internalType": "bool",
    "name": "isActive",
    "type": "bool"
  }],
  "name": "LiquidityGuardStatus",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
    "indexed": false,
    "internalType": "uint256",
    "name": "totalShares",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "totalStaked",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "shareRate",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "referrerShares",
    "type": "uint256"
  }, {
    "indexed": true,
    "internalType": "uint256",
    "name": "currentWiseDay",
    "type": "uint256"
  }],
  "name": "NewGlobals",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
    "indexed": false,
    "internalType": "uint256",
    "name": "newSharePrice",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "oldSharePrice",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint64",
    "name": "currentWiseDay",
    "type": "uint64"
  }],
  "name": "NewSharePrice",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
    "indexed": true,
    "internalType": "address",
    "name": "staker",
    "type": "address"
  }, {
    "indexed": true,
    "internalType": "bytes16",
    "name": "stakeID",
    "type": "bytes16"
  }, {
    "indexed": true,
    "internalType": "address",
    "name": "referrer",
    "type": "address"
  }, {
    "indexed": false,
    "internalType": "bytes16",
    "name": "referrerID",
    "type": "bytes16"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "rewardAmount",
    "type": "uint256"
  }],
  "name": "ReferralCollected",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
    "indexed": true,
    "internalType": "bytes16",
    "name": "stakeID",
    "type": "bytes16"
  }, {
    "indexed": true,
    "internalType": "address",
    "name": "stakerAddress",
    "type": "address"
  }, {
    "indexed": true,
    "internalType": "address",
    "name": "referralAddress",
    "type": "address"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "stakedAmount",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "stakesShares",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "referralShares",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "rewardAmount",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "closeDay",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "penaltyAmount",
    "type": "uint256"
  }],
  "name": "StakeEnd",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
    "indexed": true,
    "internalType": "bytes16",
    "name": "stakeID",
    "type": "bytes16"
  }, {
    "indexed": true,
    "internalType": "address",
    "name": "stakerAddress",
    "type": "address"
  }, {
    "indexed": true,
    "internalType": "address",
    "name": "referralAddress",
    "type": "address"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "stakedAmount",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "stakesShares",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "referralShares",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "startDay",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "lockDays",
    "type": "uint256"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "daiEquivalent",
    "type": "uint256"
  }],
  "name": "StakeStart",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
    "indexed": true,
    "internalType": "address",
    "name": "from",
    "type": "address"
  }, {
    "indexed": true,
    "internalType": "address",
    "name": "to",
    "type": "address"
  }, {
    "indexed": false,
    "internalType": "uint256",
    "name": "value",
    "type": "uint256"
  }],
  "name": "Transfer",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
    "indexed": false,
    "internalType": "uint112",
    "name": "reserveA",
    "type": "uint112"
  }, {
    "indexed": false,
    "internalType": "uint112",
    "name": "reserveB",
    "type": "uint112"
  }, {
    "indexed": false,
    "internalType": "uint32",
    "name": "blockTimestampLast",
    "type": "uint32"
  }],
  "name": "UniswapReserves",
  "type": "event"
}, {
  "inputs": [],
  "name": "INFLATION_RATE",
  "outputs": [{
    "internalType": "uint32",
    "name": "",
    "type": "uint32"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "LIQUIDITY_GUARD",
  "outputs": [{
    "internalType": "contract ILiquidityGuard",
    "name": "",
    "type": "address"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "LIQUIDITY_RATE",
  "outputs": [{
    "internalType": "uint32",
    "name": "",
    "type": "uint32"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "LIQUIDITY_TRANSFORMER",
  "outputs": [{
    "internalType": "address",
    "name": "",
    "type": "address"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "UNISWAP_FACTORY",
  "outputs": [{
    "internalType": "contract IUniswapV2Factory",
    "name": "",
    "type": "address"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "UNISWAP_PAIR",
  "outputs": [{
    "internalType": "contract IUniswapV2Pair",
    "name": "",
    "type": "address"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "UNISWAP_ROUTER",
  "outputs": [{
    "internalType": "contract IUniswapRouterV2",
    "name": "",
    "type": "address"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "owner",
    "type": "address"
  }, {
    "internalType": "address",
    "name": "spender",
    "type": "address"
  }],
  "name": "allowance",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "spender",
    "type": "address"
  }, {
    "internalType": "uint256",
    "name": "amount",
    "type": "uint256"
  }],
  "name": "approve",
  "outputs": [{
    "internalType": "bool",
    "name": "",
    "type": "bool"
  }],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "account",
    "type": "address"
  }],
  "name": "balanceOf",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint256",
    "name": "amount",
    "type": "uint256"
  }],
  "name": "burn",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_staker",
    "type": "address"
  }, {
    "internalType": "bytes16",
    "name": "_liquidityStakeID",
    "type": "bytes16"
  }],
  "name": "checkLiquidityStakeByID",
  "outputs": [{
    "internalType": "uint256",
    "name": "startDay",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "stakedAmount",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "rewardAmount",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "closeDay",
    "type": "uint256"
  }, {
    "internalType": "bool",
    "name": "isActive",
    "type": "bool"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_staker",
    "type": "address"
  }, {
    "internalType": "bytes16",
    "name": "_stakeID",
    "type": "bytes16"
  }],
  "name": "checkMatureStake",
  "outputs": [{
    "internalType": "bool",
    "name": "isMature",
    "type": "bool"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_referrer",
    "type": "address"
  }, {
    "internalType": "bytes16",
    "name": "_referralID",
    "type": "bytes16"
  }],
  "name": "checkReferralsByID",
  "outputs": [{
    "internalType": "address",
    "name": "staker",
    "type": "address"
  }, {
    "internalType": "bytes16",
    "name": "stakeID",
    "type": "bytes16"
  }, {
    "internalType": "uint256",
    "name": "referrerShares",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "referralInterest",
    "type": "uint256"
  }, {
    "internalType": "bool",
    "name": "isActiveReferral",
    "type": "bool"
  }, {
    "internalType": "bool",
    "name": "isActiveStake",
    "type": "bool"
  }, {
    "internalType": "bool",
    "name": "isMatureStake",
    "type": "bool"
  }, {
    "internalType": "bool",
    "name": "isEndedStake",
    "type": "bool"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_staker",
    "type": "address"
  }, {
    "internalType": "bytes16",
    "name": "_stakeID",
    "type": "bytes16"
  }],
  "name": "checkStakeByID",
  "outputs": [{
    "internalType": "uint256",
    "name": "startDay",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "lockDays",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "finalDay",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "closeDay",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "scrapeDay",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "stakedAmount",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "stakesShares",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "rewardAmount",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "penaltyAmount",
    "type": "uint256"
  }, {
    "internalType": "bool",
    "name": "isActive",
    "type": "bool"
  }, {
    "internalType": "bool",
    "name": "isMature",
    "type": "bool"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint256",
    "name": "_liquidityTokens",
    "type": "uint256"
  }],
  "name": "createLiquidityStake",
  "outputs": [{
    "internalType": "bytes16",
    "name": "liquidityStakeID",
    "type": "bytes16"
  }],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [],
  "name": "createPair",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint256",
    "name": "_stakedAmount",
    "type": "uint256"
  }, {
    "internalType": "uint64",
    "name": "_lockDays",
    "type": "uint64"
  }, {
    "internalType": "address",
    "name": "_referrer",
    "type": "address"
  }],
  "name": "createStake",
  "outputs": [{
    "internalType": "bytes16",
    "name": "",
    "type": "bytes16"
  }, {
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }, {
    "internalType": "bytes16",
    "name": "referralID",
    "type": "bytes16"
  }],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint256[]",
    "name": "_stakedAmount",
    "type": "uint256[]"
  }, {
    "internalType": "uint64[]",
    "name": "_lockDays",
    "type": "uint64[]"
  }, {
    "internalType": "address[]",
    "name": "_referrer",
    "type": "address[]"
  }],
  "name": "createStakeBulk",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint64",
    "name": "_lockDays",
    "type": "uint64"
  }, {
    "internalType": "address",
    "name": "_referrer",
    "type": "address"
  }],
  "name": "createStakeWithETH",
  "outputs": [{
    "internalType": "bytes16",
    "name": "",
    "type": "bytes16"
  }, {
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }, {
    "internalType": "bytes16",
    "name": "referralID",
    "type": "bytes16"
  }],
  "stateMutability": "payable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_tokenAddress",
    "type": "address"
  }, {
    "internalType": "uint256",
    "name": "_tokenAmount",
    "type": "uint256"
  }, {
    "internalType": "uint64",
    "name": "_lockDays",
    "type": "uint64"
  }, {
    "internalType": "address",
    "name": "_referrer",
    "type": "address"
  }],
  "name": "createStakeWithToken",
  "outputs": [{
    "internalType": "bytes16",
    "name": "",
    "type": "bytes16"
  }, {
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }, {
    "internalType": "bytes16",
    "name": "referralID",
    "type": "bytes16"
  }],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "",
    "type": "address"
  }],
  "name": "criticalMass",
  "outputs": [{
    "internalType": "uint256",
    "name": "totalAmount",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "activationDay",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "currentWiseDay",
  "outputs": [{
    "internalType": "uint64",
    "name": "",
    "type": "uint64"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "decimals",
  "outputs": [{
    "internalType": "uint8",
    "name": "",
    "type": "uint8"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "bytes16",
    "name": "_liquidityStakeID",
    "type": "bytes16"
  }],
  "name": "endLiquidityStake",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "bytes16",
    "name": "_stakeID",
    "type": "bytes16"
  }],
  "name": "endStake",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "x",
    "type": "address"
  }, {
    "internalType": "uint256",
    "name": "y",
    "type": "uint256"
  }, {
    "internalType": "bytes1",
    "name": "z",
    "type": "bytes1"
  }],
  "name": "generateID",
  "outputs": [{
    "internalType": "bytes16",
    "name": "b",
    "type": "bytes16"
  }],
  "stateMutability": "pure",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_referrer",
    "type": "address"
  }],
  "name": "giveStatus",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [],
  "name": "globals",
  "outputs": [{
    "internalType": "uint256",
    "name": "totalStaked",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "totalShares",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "sharePrice",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "currentWiseDay",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "referralShares",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "liquidityShares",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "isLiquidityGuardActive",
  "outputs": [{
    "internalType": "bool",
    "name": "",
    "type": "bool"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "latestDaiEquivalent",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_staker",
    "type": "address"
  }],
  "name": "latestLiquidityStakeID",
  "outputs": [{
    "internalType": "bytes16",
    "name": "",
    "type": "bytes16"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_referrer",
    "type": "address"
  }],
  "name": "latestReferralID",
  "outputs": [{
    "internalType": "bytes16",
    "name": "",
    "type": "bytes16"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_staker",
    "type": "address"
  }],
  "name": "latestStakeID",
  "outputs": [{
    "internalType": "bytes16",
    "name": "",
    "type": "bytes16"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "liquidityGuardTrigger",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "",
    "type": "address"
  }],
  "name": "liquidityStakeCount",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "",
    "type": "address"
  }, {
    "internalType": "bytes16",
    "name": "",
    "type": "bytes16"
  }],
  "name": "liquidityStakes",
  "outputs": [{
    "internalType": "uint256",
    "name": "stakedAmount",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "rewardAmount",
    "type": "uint256"
  }, {
    "internalType": "uint64",
    "name": "startDay",
    "type": "uint64"
  }, {
    "internalType": "uint64",
    "name": "closeDay",
    "type": "uint64"
  }, {
    "internalType": "bool",
    "name": "isActive",
    "type": "bool"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "name": "lsnapshots",
  "outputs": [{
    "internalType": "uint256",
    "name": "totalShares",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "inflationAmount",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "manualDailySnapshot",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint64",
    "name": "_updateDay",
    "type": "uint64"
  }],
  "name": "manualDailySnapshotPoint",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_investorAddress",
    "type": "address"
  }, {
    "internalType": "uint256",
    "name": "_amount",
    "type": "uint256"
  }],
  "name": "mintSupply",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [],
  "name": "name",
  "outputs": [{
    "internalType": "string",
    "name": "",
    "type": "string"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "",
    "type": "address"
  }],
  "name": "referralCount",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "name": "referralSharesToEnd",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_referrer",
    "type": "address"
  }, {
    "internalType": "uint256",
    "name": "_offset",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "_length",
    "type": "uint256"
  }],
  "name": "referralsPagination",
  "outputs": [{
    "internalType": "bytes16[]",
    "name": "_referrals",
    "type": "bytes16[]"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "bytes16",
    "name": "_referralID",
    "type": "bytes16"
  }, {
    "internalType": "uint256",
    "name": "_scrapeDays",
    "type": "uint256"
  }],
  "name": "referrerInterest",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "bytes16[]",
    "name": "_referralIDs",
    "type": "bytes16[]"
  }, {
    "internalType": "uint256[]",
    "name": "_scrapeDays",
    "type": "uint256[]"
  }],
  "name": "referrerInterestBulk",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "",
    "type": "address"
  }, {
    "internalType": "bytes16",
    "name": "",
    "type": "bytes16"
  }],
  "name": "referrerLinks",
  "outputs": [{
    "internalType": "address",
    "name": "staker",
    "type": "address"
  }, {
    "internalType": "bytes16",
    "name": "stakeID",
    "type": "bytes16"
  }, {
    "internalType": "uint256",
    "name": "rewardAmount",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "processedDays",
    "type": "uint256"
  }, {
    "internalType": "bool",
    "name": "isActive",
    "type": "bool"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "name": "rsnapshots",
  "outputs": [{
    "internalType": "uint256",
    "name": "totalShares",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "inflationAmount",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "scheduledToEnd",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "name": "scheduledToEnd",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "bytes16",
    "name": "_stakeID",
    "type": "bytes16"
  }, {
    "internalType": "uint64",
    "name": "_scrapeDays",
    "type": "uint64"
  }],
  "name": "scrapeInterest",
  "outputs": [{
    "internalType": "uint256",
    "name": "scrapeDay",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "scrapeAmount",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "remainingDays",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "stakersPenalty",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "referrerPenalty",
    "type": "uint256"
  }],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "",
    "type": "address"
  }, {
    "internalType": "bytes16",
    "name": "",
    "type": "bytes16"
  }],
  "name": "scrapes",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_immutableTransformer",
    "type": "address"
  }],
  "name": "setLiquidityTransfomer",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "name": "snapshots",
  "outputs": [{
    "internalType": "uint256",
    "name": "totalShares",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "inflationAmount",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "scheduledToEnd",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "",
    "type": "address"
  }],
  "name": "stakeCount",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "",
    "type": "address"
  }, {
    "internalType": "bytes16",
    "name": "",
    "type": "bytes16"
  }],
  "name": "stakes",
  "outputs": [{
    "internalType": "uint256",
    "name": "stakesShares",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "stakedAmount",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "rewardAmount",
    "type": "uint256"
  }, {
    "internalType": "uint64",
    "name": "startDay",
    "type": "uint64"
  }, {
    "internalType": "uint64",
    "name": "lockDays",
    "type": "uint64"
  }, {
    "internalType": "uint64",
    "name": "finalDay",
    "type": "uint64"
  }, {
    "internalType": "uint64",
    "name": "closeDay",
    "type": "uint64"
  }, {
    "internalType": "uint256",
    "name": "scrapeDay",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "daiEquivalent",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "referrerShares",
    "type": "uint256"
  }, {
    "internalType": "address",
    "name": "referrer",
    "type": "address"
  }, {
    "internalType": "bool",
    "name": "isActive",
    "type": "bool"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "_staker",
    "type": "address"
  }, {
    "internalType": "uint256",
    "name": "_offset",
    "type": "uint256"
  }, {
    "internalType": "uint256",
    "name": "_length",
    "type": "uint256"
  }],
  "name": "stakesPagination",
  "outputs": [{
    "internalType": "bytes16[]",
    "name": "_stakes",
    "type": "bytes16[]"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "symbol",
  "outputs": [{
    "internalType": "string",
    "name": "",
    "type": "string"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "name": "totalPenalties",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "totalSupply",
  "outputs": [{
    "internalType": "uint256",
    "name": "",
    "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "recipient",
    "type": "address"
  }, {
    "internalType": "uint256",
    "name": "amount",
    "type": "uint256"
  }],
  "name": "transfer",
  "outputs": [{
    "internalType": "bool",
    "name": "",
    "type": "bool"
  }],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
    "internalType": "address",
    "name": "sender",
    "type": "address"
  }, {
    "internalType": "address",
    "name": "recipient",
    "type": "address"
  }, {
    "internalType": "uint256",
    "name": "amount",
    "type": "uint256"
  }],
  "name": "transferFrom",
  "outputs": [{
    "internalType": "bool",
    "name": "",
    "type": "bool"
  }],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [],
  "name": "transformerGateKeeper",
  "outputs": [{
    "internalType": "address",
    "name": "",
    "type": "address"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "stateMutability": "payable",
  "type": "receive"
}]
